import React, { useEffect, useRef, useState } from 'react'
import { AdminDrawerList } from '../../components/AdminDrawerList'
import { AccountBalanceWallet, AccountBox, Add, Category, Dashboard, ElectricBolt, IntegrationInstructions, Inventory, Logout, Receipt, Sell, ShoppingBag } from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';
import { AdminRoutes } from '../../../Routes/AdminRoutes';
import { useAppDispatch } from '../../../State/Store';
import { fetchHomeCategories } from '../../../State/admin/adminSlice';
import { Box } from '@mui/material';
const menu = [
    {
      name: "Dashboard",
      path: "/admin",
      icon: <Dashboard className="text-primary" />,
      activeIcon: <Dashboard className="text-white" />,
    },
    {
      name: "Coupons",
      path: "/admin/coupons",
      icon: <IntegrationInstructions className="text-primary" />,
      activeIcon: <IntegrationInstructions className="text-white" />,
    },
    {
      name: "Add New Coupon",
      path: "/admin/add-coupon",
      icon: <Add className="text-primary" />,
      activeIcon: <Add className="text-white" />,
    },
    {
        name: "Home Page",
        path: "/admin/homepage",
        icon: <HomeIcon className="text-primary" />,
        activeIcon: <HomeIcon className="text-white" />,
      },
    {
      name: "Electronics Category",
      path: "/admin/electronics-category",
      icon: <ElectricBolt className="text-primary" />,
      activeIcon: <ElectricBolt className="text-white" />,
    },
    {
      name: "Shop By Category",
      path: "/admin/shopby-category",
      icon: <Category className="text-primary" />,
      activeIcon: <Category className="text-white" />,
    },
    {
        name: "Deals",
        path: "/admin/deals",
        icon: <Sell className="text-primary" />,
        activeIcon: <Sell className="text-white" />,
      },
  ];
  
  const menu2 = [
    {
      name: "Account",
      path: "/admin/account",
      icon: <AccountBox className="text-primary" />,
      activeIcon: <AccountBox className="text-white" />,
    },
    {
      name: "Logout",
      path: "/",
      icon: <Logout className="text-primary" />,
      activeIcon: <Logout className="text-white" />,
    },
  ];
  
export const AdminDashBoard = () => {
    const toggleDrawer = () => {  }
    const dispatch = useAppDispatch();
    const [height, setHeight] = useState(0);
    const mainRef = useRef<HTMLDivElement>(null);
    useEffect(() => { 
      dispatch(fetchHomeCategories())
     },[])
  return (
    <div className="">
      <div className="lg:flex lg:h-[100%]">
       
        <aside
            className="hidden lg:block h-full lg:pr-6 self-start lg:sticky lg:top-24"
           
          > <AdminDrawerList menu2={menu2}  menu={menu} toggleDrawer={toggleDrawer}/>
            </aside>
        {/* redirect to related route */}
        <Box sx={{ flexGrow: 2 }} ref={mainRef} className="pt-10 w-full lg:w-[80%] justify-start  flex flex-col  h-full">
          <AdminRoutes/>
        </Box>
      </div>
    </div>
  )
}
